import { OctagonAlert } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const ncrNav: NavEntry = {
  label: 'Quality issues (NCRs)',
  icon: OctagonAlert,
  path: '/quality/nonconformances',
  permission: 'ncr:read',
  order: 16,
}
